import React, { useEffect, useState } from 'react';
import "./Style/common.css";
import "./Style/header.css";
import "./Style/DoMore.css";
import $ from "jquery";
import activity_icon_lesson from "./Image/activity_icon_lesson.png";
import Header from "../../Common/Header";
import Loading from "../../Common/Loading";
import { useNavigate } from "react-router-dom";
interface DataItem {
  dicfilename: string;
  lessoncode: string;
  unitcode?: string;
  chaptercode?: string;
  activitytype: string;
  childshortdesc: string;
  btntext: string;
}
 
interface Activity {
  dicfilename?: string;
  lessoncode: string;
  unitcode: string;
  chaptercode: string;
  activitytype: string;
  howshifted: string | null;
  completedflag: string | null;
  lastscore: number | null;
  lastdoneon: string | null;
  ChildShortDesc: string;
  FileID?: string;
  LevelNo?: number;
  DicCode?: string;
  type?: string;
}
 
 
const DoMore: React.FC = () => {
  const apiUrl = process.env.REACT_APP_DOCUMENT_LINK ;
  const [data, setData] = useState<DataItem>({
    dicfilename: '',
    lessoncode: '',
    activitytype: '',
    childshortdesc: '',
    btntext: '',
  });
  const [loading, setLoading] = useState<boolean>(true);
  const [startError, setStartError] = useState<string>("");
  const navigate = useNavigate();
 
  useEffect(() => {
    setLoading(true);
    fetch(`${apiUrl}do_more/`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${sessionStorage.getItem("access_token")}`,
      },
      body: JSON.stringify({
        SchoolCode: sessionStorage.getItem("SchoolCode"),
        FamilyCode: sessionStorage.getItem("FamilyCode"),
        Login: sessionStorage.getItem("Login"),
        Subject: sessionStorage.getItem("Subject"),
      }),
    })
      .then((response) => response.json())
      .then((response) => {
        const activity = Array.isArray(response)
          ? response[0]
          : Array.isArray(response?.data)
            ? response.data[0]
            : response?.data || response;

        if (
          !activity ||
          typeof activity !== "object" ||
          !activity.lessoncode ||
          !activity.activitytype
        ) {
          console.log("No activity available, redirecting to Study Room");
          navigate("/STUDENT/MSR/StudyRoom");
          return;
        }
        setData(activity);
        setLoading(false);
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
        setLoading(false);
      });
  }, []);
 
  useEffect(() => {
    const handleTopClick = () => {
      window.scrollTo({ top: 0, behavior: "smooth" });
    };
    const handleBottomClick = () => {
      window.scrollTo({ top: document.body.scrollHeight, behavior: "smooth" });
    };
    $(".back-to-top").on("click", handleTopClick);
    $(".back-to-bottom").on("click", handleBottomClick);
    return () => {
      $(".back-to-top").off("click", handleTopClick);
      $(".back-to-bottom").off("click", handleBottomClick);
    };
  }, []);
  const getActivityLink = (activity: Activity): string => {
    const { activitytype, lessoncode, DicCode } = activity;
    const dicFileVersionParam = sessionStorage.getItem("DICFileVersion") || 1;
    const calledFrom = encodeURIComponent("/STUDENT/MSR/DoMore"); 
    const hwidParam = "&hwid=0";

    if (activitytype === "G") {
        return `/STUDENT/Tutorials/Game?LsnTestCode=${lessoncode+"_E"}&calledFrom=${calledFrom}${hwidParam}`;
    }
    if ((activitytype === "T")) {
        return `/STUDENT/Tutorials/ConfirmTest?DicCode=${DicCode}&DicVersion=${dicFileVersionParam}&LsnTestCode=${lessoncode}&name=${activity.ChildShortDesc}&calledFrom=${calledFrom}${hwidParam}`;
    }
    if (activitytype === "L") {
        return `/STUDENT/Tutorials/Tutorial?id=${lessoncode+"_E"}&DicVersion=${dicFileVersionParam}&name=${activity.ChildShortDesc}&folder=${DicCode}&calledFrom=${calledFrom}${hwidParam}`;
    }
    return "";
  };
 
const handleStartActivity = async () => {
  const activity: Activity = {
    lessoncode: data.lessoncode,
    activitytype: data.activitytype,
    ChildShortDesc: data.childshortdesc,
    DicCode: data.dicfilename,
    unitcode: data.unitcode || "",
    chaptercode: data.chaptercode || "",
    howshifted: null,
    completedflag: null,
    lastscore: null,
    lastdoneon: null,
  };

  setStartError("");

  try {
    const response = await fetch(`${apiUrl}start_do_more/`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${sessionStorage.getItem("access_token")}`,
      },
      body: JSON.stringify({
        SchoolCode: sessionStorage.getItem("SchoolCode"),
        FamilyCode: sessionStorage.getItem("FamilyCode"),
        Login: sessionStorage.getItem("Login"),
        Subject: sessionStorage.getItem("Subject"),
        DicFileName: data.dicfilename,
        LessonCode: data.lessoncode
      }),
    });

    const result = await response.json();
    if (!response.ok || result?.success !== true) {
      throw new Error(result?.message || "Unable to update the activity.");
    }
  } catch (error) {
    console.error("Error activating Do More activity:", error);
    setStartError(
      error instanceof Error ? error.message : "Unable to update the activity."
    );
    return;
  }

  sessionStorage.setItem("LsnTestCode", activity.lessoncode || "");
  sessionStorage.setItem("UnitCode", activity.unitcode || "");
  sessionStorage.setItem("ChapterCode", activity.chaptercode || "");
  sessionStorage.setItem("DICFileVersion", "1");

  if (activity.DicCode) {
      sessionStorage.setItem("SelectedDICFile", activity.DicCode);
  }

  const link = getActivityLink(activity);
  navigate(link);
};
 
 
  return (
    <form id="form1">
      <a href="DoMore" className="back-to-top">Back to Top</a>
      <a href="DoMore" className="back-to-bottom" id="back_to_bottom_link">Back to Bottom</a>
      <div id="main_top_container">
        <Header />
 
          <div id="wlp_add_activity">
            <p>
              <span className="title_text wlp_add_activity_title_text">Here is your next activity</span>
            </p>
                    {loading ? (
          <Loading />
        ) : (
          <>
            {startError && (
              <p role="alert" className="error_message">
                {startError}
              </p>
            )}
                      <div className="activity_btn_and_tip_container">
              <div className="tip_container">
                <label id="lblWLPText">New activity</label>
              </div>
              <div id="lnkStartActivity" className="activity_btn" onClick={handleStartActivity} style={{cursor: 'pointer'}}>
                <span id="spnWLPicon"
                                  className={`activity_icon ${
                                    data?.activitytype?.toLowerCase() === "t"
                                      ? "wlp_list_current_activity_icon_test"
                                      : data?.activitytype?.toLowerCase() === "g"
                                        ? "wlp_list_current_activity_icon_game"
                                        : "wlp_list_current_activity_icon_lesson"
                                  }`}></span>
                <label id="lblActivityName" style={{cursor: 'pointer'}}>{data.childshortdesc}</label>
                <span className="button_right_text">
                  <span id="lblWLPHeading">{data.btntext === "" ? "Get Started" : data.btntext }</span>
                </span>
              </div>
            </div>
            <div className="subject_middle_gap"></div>
            <div className="button_box">
              <div id="wlp_add_activity_cancel_btn" className="general_btn two_btn_lightbox">
                <a id="lnkbtnCancel" href='/STUDENT/MSR/StudyRoom'>Cancel</a>
              </div>
            </div>
          </>
            )}
          </div>
      </div>
      <div id="dialog-confirm" title="">
        <span id="spnText"></span>
      </div>
    </form>
  );
};

export default DoMore;
